import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Form, Message, Icon, Button } from "semantic-ui-react";
import { enums, validators } from "../../helpers";
import { BankDetails } from "../../components";
import IBAN from "iban";
import config from "../../config";

import "semantic-ui-css/components/modal.min.css";
import "semantic-ui-css/components/dimmer.min.css";
import "semantic-ui-css/components/transition.min.css";
import "semantic-ui-css/components/tab.min.css";
import "semantic-ui-css/components/menu.min.css";
import "semantic-ui-css/components/segment.min.css";
import "semantic-ui-css/components/form.min.css";
import "semantic-ui-css/components/dropdown.min.css";
import "semantic-ui-css/components/message.min.css";

import "./NewRefundRequestModal.css";

const priorityOptions = [
  {
    key: "HIGH",
    value: "HIGH",
    text: (
      <span className="priority-icon-form">
        <Icon name="angle double up" color="red" /> High
      </span>
    )
  },
  {
    key: "NORMAL",
    value: "NORMAL",
    text: (
      <span className="priority-icon-form">
        <Icon name="angle double down" color="green" /> Normal
      </span>
    )
  }
];

export default class NewRefundRequestModal extends Component {
  static propTypes = {
    trigger: PropTypes.element,
    getZendeskData: PropTypes.func,
    createRequest: PropTypes.func,
    zendeskData: PropTypes.obj,
    zendeskDataLoading: PropTypes.bool,
    zendeskDataLoaded: PropTypes.bool,
    readOnly: PropTypes.bool,
    initialValues: PropTypes.obj
  };

  constructor(props) {
    super(props);
    this.state = {
      zendeskTicket: this.props.initialZendeskTicket,
      country: null,
      operator: null,
      service: null,
      priority: null,
      method: null,
      status: "NEW",
      msisdn: null,
      currency: null,
      amount: null,
      processingFee: 0,
      name: null,
      email: null,
      entity: "",
      comment: "",
      confirmOpen: false,
      warning: null,
      errors: {}
    };
    this.confirmOpen = false;
  }

  componentDidUpdate(props) {
    if (this.props.initialZendeskTicket !== props.initialZendeskTicket) {
      this.props.getZendeskData(this.props.initialZendeskTicket);
      this.setState({ zendeskTicket: this.props.initialZendeskTicket });
    }
    if (
      this.props.zendeskDataLoaded &&
      this.props.zendeskData &&
      this.props.zendeskDataLoaded !== props.zendeskDataLoaded
    ) {
      this.setState({
        country: this.props.zendeskData.operatorData.countryId,
        bankDetails: {
          name: this.props.zendeskData.custom_fields.find(
            item => item.id === config.zendeskFields.name
          )
            ? this.props.zendeskData.custom_fields.find(
                item => item.id === config.zendeskFields.name
              ).value
            : this.props.zendeskData.custom_fields.find(
              item => item.id === config.zendeskFields.nameBe
            )
              ? this.props.zendeskData.custom_fields.find(
                  item => item.id === config.zendeskFields.nameBe
                ).value
              : "",
          lastName: this.props.zendeskData.custom_fields.find(
            item => item.id === config.zendeskFields.lastName
          )
            ? this.props.zendeskData.custom_fields.find(
                item => item.id === config.zendeskFields.lastName
              ).value
            : ""
        },
        operator: this.props.zendeskData.operatorData.oc,
        service: this.props.zendeskData.dbService.id,
        msisdn: this.props.zendeskData.custom_fields.find(
          item => item.id === config.zendeskFields.msisdn
        ).value,
        currency: this.props.zendeskData.custom_fields.find(
          item => item.id === config.zendeskFields.currency
        ).value,
        amount: this.props.zendeskData.custom_fields.find(
          item => item.id === config.zendeskFields.amount
        ).value,
        processingFee: 0,
        method: this.props.zendeskData.custom_fields.find(
          item => item.id === config.zendeskFields.method
        ).value,
        name: this.props.zendeskData.user.name,
        email: this.props.zendeskData.user.email,
        priority: null,
        comment: "",
        entity: this.props.zendeskData.dbService.entity,
        status: "NEW",
        warning: this.props.zendeskData.pastRefunds
          ? `This MSISDN has had ${this.props.zendeskData.pastRefunds} tickets/refunds in the past`
          : null,
        errors: {}
      });
    }
  }

  onZendeskTicketChange = (e, { value: zendeskTicket }) => {
    this.setState({ zendeskTicket });
    //this.props.getZendeskData(zendeskTicket);
  };

  onFieldChange = field => (e, { value }) =>
    this.setState({
      [field]: value,
      errors: {
        ...this.state.errors,
        [field]: undefined
      }
    });

  onBankDetailsFieldChange = field => (e, { value }) =>
    this.setState({
      bankDetails: {
        ...this.state.bankDetails,
        [field]: value
      },
      errors: {
        ...this.state.errors,
        [`bankDetails${field}`]: undefined
      }
    });

  validateInputs = () => {
    const errors = {};
    if (!this.state.country) errors.country = "You must specify a Country";
    if (!this.state.zendeskTicket)
      errors.zendeskTicket = "You must specify a Zendesk Ticket";
    if (!this.state.operator) errors.operator = "You must specify an Operator";
    if (!this.state.service) errors.service = "You must specify a Service";
    if (!this.state.msisdn) errors.msisdn = "You must specify an MSISDN";
    if (!this.state.currency) errors.currency = "You must specify a Currency";
    if (!this.state.amount) errors.amount = "You must specify an Amount";
    if (!this.state.method) errors.method = "You must specify a Refund Method";
    if (!this.state.name) errors.name = "You must specify a Name";
    //if (!this.state.email) errors.email = "You must specify an E-mail"; // Email is not mandatory
    if (!this.state.priority) errors.priority = "You must specify a Priority";
    if (!this.state.entity) errors.entity = "You must specify a entity";
    if (!this.props.zendeskDataLoaded)
      errors.dataLoaded =
        "No zendesk data loaded, please enter a valid zendesk ticket";
    if (
      this.state.method === "pending_information" ||
      this.state.method === "to_be_defined"
    )
      errors.method = "Refund method can't be Pending";
    if (this.state.email && !validators.validateEmail(this.state.email))
      errors.email = "Email not valid";
    if (this.state.msisdn && !validators.validateMSISDN(this.state.msisdn))
      errors.msisdn = "MSISDN not valid";
    if (this.state.amount && !validators.validateNumber(this.state.amount))
      errors.amount = "Amount not valid";
    if (
      this.state.processingFee &&
      !validators.validateNumber(this.state.processingFee) &&
      this.state.processingFee < 0
    )
      errors.processingFee = "processing fee not valid";
    if (
      this.state.zendeskTicket &&
      !validators.validateNumber(this.state.zendeskTicket)
    )
      errors.zendeskTicket = "Zendesk ticket # not valid";
    if (!this.state.bankDetails)
      errors.bankDetailsFields = "You didn't enter any bank details";
    if (this.state.entity && this.state.method) {
      enums.entityToRefundMethod[this.state.entity][this.state.method].forEach(
        field => {
          if (
            !this.state.bankDetails[field] &&
            this.state.method !== "bill_payment"
          ) {
            errors[
              `bankDetails${field}`
            ] = `You must specify ${enums.bankDetails[field]}`;
          }
        }
      );
      if (
        enums.entityToRefundMethod[this.state.entity][
          this.state.method
        ].includes("iban") &&
        this.state.bankDetails.iban &&
        !IBAN.isValid(this.state.bankDetails.iban)
      )
        errors.bankDetailsiban = "IBAN is not valid";
    }
    return errors;
  };

  handleSubmit = () => {
    const errors = this.validateInputs();
    document.getElementsByClassName("NewReqModelContent")[0].scrollTo(0, 0);
    if (Object.keys(errors).length) {
      this.setState({ errors });
    } else {
      const { errors, warning, ...fields } = this.state;
      this.resetFields();
      this.props.close();
      this.props.createRefund(fields);
    }
  };

  resetFields = () =>
    this.setState({
      zendeskTicket: "",
      country: "",
      operator: "",
      service: "",
      priority: "",
      method: "",
      status: "NEW",
      msisdn: "",
      currency: "",
      amount: "",
      processingFee: 0,
      name: "",
      email: "",
      entity: "",
      comment: "",
      warning: null,
      errors: {}
    });

  closeModal = () => {
    if (
      this.state.zendeskTicket &&
      this.state.zendeskTicket.length &&
      this.state.confirmOpen !== "closing" &&
      !this.state.confirmOpen
    ) {
      this.setState({ confirmOpen: true });
    } else if (
      !this.state.confirmOpen &&
      this.state.confirmOpen !== "closing"
    ) {
      this.resetFields();
      this.props.close();
    } else if (this.state.confirmOpen === "closing")
      this.setState({ confirmOpen: false });
  };

  closeConfirm = () => {
    this.setState({ confirmOpen: "closing" });
  };

  confirmCloseModal = () => {
    this.setState({ confirmOpen: false });
    this.resetFields();
    this.props.close();
  };

  renderProcessingFeeField = () => {
    console.log("REFUND METHOD:", this.state.method);
    if (this.state.method === "topup") {
      return (
        <Form.Input
          label="Processing Fee"
          value={this.state.processingFee}
          error={this.state.errors && this.state.errors.processingFee}
          fluid
          onChange={this.onFieldChange("processingFee")}
        />
      );
    }

    return "";
  };
  //this.props.getZendeskData(zendeskTicket);
  getZendeskData = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { zendeskTicket } = this.state;
    if (zendeskTicket) this.props.getZendeskData(this.state.zendeskTicket);
    else this.setState({ errors: {...this.state.errors, zendeskTicket: 'Please enter a zendesktickt id'}});
  };

  render() {
    const countries = this.props.operators
      ? this.props.operators.reduce(
          (countriesCurr, operator) => ({
            ...countriesCurr,
            [operator.countryId]: operator.countryName
          }),
          {}
        )
      : {};

    const countryOptions = Object.keys(countries)
      .map(Number)
      .map(countryId => ({
        key: countryId,
        value: countryId,
        text: countries[countryId]
      }));
    const operatorOptions = this.state.country
      ? this.props.operators
          .filter(operator => operator.countryId === this.state.country)
          .map(operator => ({
            key: operator.oc,
            value: operator.oc,
            text: operator.operatorName
          }))
      : [];
    const serviceOptions = this.state.operator
      ? this.props.operators
          .find(operator => operator.oc === this.state.operator)
          .services.map(service => ({
            key: service.id,
            value: service.id,
            text: service.name
          }))
      : [];

    return (
      <div>
        <Modal
          className="NewRefundRequestModal"
          trigger={this.props.trigger}
          open={this.props.open}
          onClose={this.closeModal}
          mountNode={document.getElementById("root")}
          closeIcon
        >
          <Modal.Header>New Request</Modal.Header>
          <Modal.Content scrolling className="NewReqModelContent">
            {this.state.warning ? (
              <Message
                warning
                size="mini"
                header="Warning"
                content={this.state.warning}
              />
            ) : null}
            {this.state.errors &&
            Object.values(this.state.errors).filter(item => item).length ? (
              <Message
                error
                size="mini"
                header="Oops, Something Went Wrong"
                list={[
                  ...Object.values(this.state.errors).filter(item => item)
                ]}
              />
            ) : null}
            <Form className="TicketContent" size="mini">
              <div className="former-group" style={{overflow: "hidden"}}>
                <Form.Input
                  loading={this.props.zendeskDataLoading}
                  value={this.state.zendeskTicket}
                  placeholder="Zendesk Ticket"
                  onChange={this.onZendeskTicketChange}
                  required
                  error={this.state.errors && this.state.errors.zendeskTicket}
                  label="ZenDesk Ticket #"
                  type="number"
                />
                <div className="field pull-right">
                  <button className="ui button primary" onClick={this.getZendeskData}>Get Ticket</button>
                </div>
              </div>
              <div className="former-group">
                <Form.Dropdown
                  label="Country"
                  loading={this.props.zendeskDataLoading}
                  onChange={this.onFieldChange("country")}
                  value={this.state.country}
                  selection
                  required
                  error={this.state.errors && this.state.errors.country}
                  options={countryOptions}
                  disabled={!this.props.zendeskDataLoaded}
                />
                <Form.Dropdown
                  label="Operator"
                  loading={this.props.zendeskDataLoading}
                  onChange={this.onFieldChange("operator")}
                  value={this.state.operator}
                  selection
                  required
                  error={this.state.errors && this.state.errors.operator}
                  options={operatorOptions}
                  disabled={!this.props.zendeskDataLoaded}
                />
                <Form.Dropdown
                  label="Service"
                  loading={this.props.zendeskDataLoading}
                  onChange={this.onFieldChange("service")}
                  value={this.state.service}
                  selection
                  required
                  error={this.state.errors && this.state.errors.service}
                  options={serviceOptions}
                  disabled={!this.props.zendeskDataLoaded}
                />
              </div>
              <div className="former-group">
                <Form.Input
                  fluid
                  label="Entity"
                  required
                  onChange={this.onFieldChange("entity")}
                  readOnly
                  value={this.state.entity}
                  error={this.state.errors && this.state.errors.entity}
                  disabled={!this.props.zendeskDataLoaded}
                />
                <Form.Dropdown
                  label="Refund Method"
                  loading={this.props.zendeskDataLoading}
                  onChange={this.onFieldChange("method")}
                  value={this.state.method}
                  selection
                  required
                  error={this.state.errors && this.state.errors.method}
                  options={Object.keys(enums.refundMethods).map(method => ({
                    key: method,
                    value: method,
                    text: enums.refundMethods[method],
                    disabled: !(
                      this.state.entity &&
                      Object.keys(
                        enums.entityToRefundMethod[this.state.entity]
                      ).includes(method)
                    )
                  }))}
                  disabled={!this.props.zendeskDataLoaded}
                />
                {this.state.entity && this.state.method ? (
                  <BankDetails
                    initialValues={this.state.bankDetails}
                    entity={this.state.entity}
                    refundMethod={this.state.method}
                    onFieldChange={this.onBankDetailsFieldChange}
                    errors={this.state.errors}
                    prefix="bankDetails"
                    readOnly={!this.props.zendeskDataLoaded}
                  />
                ) : null}
              </div>
              <div className="former-group">
                <Form.Dropdown
                  label="Priority"
                  onChange={this.onFieldChange("priority")}
                  value={this.state.priority}
                  selection
                  required
                  error={this.state.errors && this.state.errors.priority}
                  options={priorityOptions}
                  disabled={!this.props.zendeskDataLoaded}
                />
              </div>
              <div className="former-group">
                <Form.Input
                  label="MSISDN"
                  required
                  loading={this.props.zendeskDataLoading}
                  value={this.state.msisdn}
                  onChange={this.onFieldChange("msisdn")}
                  error={this.state.errors && this.state.errors.msisdn}
                  disabled={!this.props.zendeskDataLoaded}
                />
                <Form.Dropdown
                  label="Currency"
                  loading={this.props.zendeskDataLoading}
                  onChange={this.onFieldChange("currency")}
                  value={this.state.currency}
                  selection
                  required
                  error={this.state.errors && this.state.errors.currency}
                  options={Object.keys(enums.currencies).map(currency => ({
                    key: currency,
                    value: currency,
                    text: enums.currencies[currency]
                  }))}
                  disabled={!this.props.zendeskDataLoaded}
                />
                <Form.Input
                  label={"Amount"}
                  required
                  loading={this.props.zendeskDataLoading}
                  onChange={this.onFieldChange("amount")}
                  value={this.state.amount}
                  error={this.state.errors && this.state.errors.amount}
                  disabled={!this.props.zendeskDataLoaded}
                />
                {this.renderProcessingFeeField()}
              </div>
              <div className="former-group">
                <Form.Input
                  label="Name"
                  required
                  loading={this.props.zendeskDataLoading}
                  onChange={this.onFieldChange("name")}
                  value={this.state.name}
                  error={this.state.errors && this.state.errors.name}
                  disabled={!this.props.zendeskDataLoaded}
                />
                <Form.Input
                  label="Email"
                  loading={this.props.zendeskDataLoading}
                  onChange={this.onFieldChange("email")}
                  value={this.state.email}
                  error={this.state.errors && this.state.errors.email}
                  disabled={!this.props.zendeskDataLoaded}
                />
              </div>
              <div className="former-group">
                <Form.TextArea
                  label="Comment (Optional)"
                  placeholder="Comment"
                  onChange={this.onFieldChange("comment")}
                  value={this.state.comment}
                  disabled={!this.props.zendeskDataLoaded}
                />
              </div>
            </Form>
          </Modal.Content>
          <div className="modaler-footer">
            <div className="modaler-footer__item">
              <Form.Button onClick={this.closeModal}>Cancel</Form.Button>
            </div>
            <div className="modaler-footer__item">
              <Form.Button
                primary
                disabled={this.props.zendeskDataLoading}
                onClick={this.handleSubmit}
              >
                Create
              </Form.Button>
            </div>
          </div>
          <Modal
            className="ConfirmCloseModal"
            open={
              this.state.confirmOpen && this.state.confirmOpen !== "closing"
            }
            mountNode={document.getElementById("root")}
            size="mini"
            onClose={this.closeConfirm}
            closeOnDimmerClick={false}
          >
            <Modal.Header>
              <i className="icon1 icon1_circle-question"></i>
              Are you sure?
            </Modal.Header>
            <Modal.Content>
              You have some unsaved changes, are you sure you want to close?
            </Modal.Content>
            <Modal.Actions>
              <Button
                className="btn"
                content="No"
                onClick={this.closeConfirm}
              />
              <Button
                className="btn btn_blue"
                content="Yes"
                onClick={this.confirmCloseModal}
              />
            </Modal.Actions>
          </Modal>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewRefundRequestModalComponent/NewRefundRequestModal.js